const urls = {
  en: 'https://launcher.erachain.org',
  ru: 'https://launcher.erachain.ru',
}

export default {
  baseURL: urls[process.env.VUE_APP_DEFAULT_LOCALE],
  locale: process.env.VUE_APP_DEFAULT_LOCALE,
}
